import { NgModule } from "@angular/core";

import { SharedModule } from "../../shared/shared.module";
import { ResidentToolbarModule } from "../../patient/resident-toolbar";

import { CreateTaskComponent } from "./create-task.component";
import { TasksDetailModule } from "../detail/tasks-detail.module";

@NgModule({
	imports: [SharedModule, TasksDetailModule, ResidentToolbarModule],
	declarations: [CreateTaskComponent],
	exports: [CreateTaskComponent],
})
export class TaskCreateModule {}
